import { DtoInclude, DtoIncludeJson, DtoRef, DtoRefList } from '../../../core/store/dto/dto';
import { Group } from '../group/group.model';
import { RestrictedAccountObjectDto } from '../restricted-account-object/restricted-account-object.dto';

export class FormDto extends RestrictedAccountObjectDto {
    @DtoInclude
    title: string;
    @DtoInclude
    description: string;
    @DtoRefList
    groups: Array<string> | Array<Group>;
    @DtoRef
    jobType: string;
    @DtoIncludeJson
    config: string;
    @DtoInclude
    geoLocationEnabled: boolean;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/form/form.dto.ts